module.exports = __webpack_public_path__ + "img/034.0b80915c.png";